import { mapValues } from 'lodash';
/**
 * Version 5 migrations registration summary widget - questions
 * - Adding default configurations for question section
 * - Adding default styling for subheaders
 */
export default function v6(website) {
  return {
    ...website,
    eventVersion: 6,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'RegistrationSummary' && !layoutItem.config.questions) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            questions: {
              display: true,
              displayType: 0,
              header: 'EventWidgets_RegistrationSummary_DefaultQuestionHeader__resx'
            },
            style: {
              ...layoutItem.config.style,
              subheaderStyles: {
                styleMapping: 'header4'
              },
              attendeeBorderStyles: {
                styleMapping: 'custom',
                border: {
                  borderStyle: 'solid',
                  color: 'primary',
                  thickness: 1
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
